module.exports = __webpack_public_path__ + "static/img/noYJnotice.1931464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/myNotice/noYJnotice.png
// module id = b8wa
// module chunks = 0